import React, { useRef, useState } from "react";
import { Button, Column, MasterDetail } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../Componentes/Basicos/LVGridCabecera";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import COM_ListasPrecios_Detalle from "./COM_ListasPrecios_Detalle";
import LVButtonNuevo from "../../Componentes/Basicos/LVButtonNuevo";

export const COM_ListasPrecios_ = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const refRecargaListado = useRef(null);
  //const { COM_ListasPrecios_Cabecera: { function_COM_ListasPrecios_Cabecera_Listar } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const onClickDelete = (e) => {
    const Item = { ...e.row.data };
    if (window.confirm('¿Está seguro que desea eliminar este registro?')) {
      
      const setData = async () => {
        try {
          //await function_NOEXISTE(Item.IdDocVenta)
          refRecargaListado.current?.(); 
        } catch (error) {
          alert(error);
        }
      }
      setData();
    }
  };

  const handleOnClickPrint = async (item) => {
    try {
      setLoading(true);
      const formato = "pdf"
      const reportData = []//= await function_VEN_DocsVenta_Cabecera_ReporteDocVenta(item, formato);

      if (formato === 'pdf') {
        const file = new Blob([reportData], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `ListaPrecioCompra${item}.pdf`; // Nombre del archivo con extensión
        link.click();
      } else if (formato === 'html') {
        const htmlContent = reportData.data;
        const newWindow = window.open();
        newWindow.document.write(htmlContent); // Mostrar HTML en nueva ventana
        newWindow.document.close();
      }

    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <PaginaListado
      Titulo="LISTAS DE PRECIOS"
      onDataLoaded={handleDataLoaded}
      refRecarga={refRecargaListado}
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonNuevo Url="/COM_ListasPrecios_ModificacionCreacion/--NUEVO--" visible={false} />
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer"
            keyExpr="CodigoListaPrecios"
            urlEdicion="/COM_ListasPrecios_ModificacionCreacion"
            onClickPrint={handleOnClickPrint}
          >            
            <Column type="buttons" name="Eliminar" width={40}>
              <Button name="Eliminar" icon="trash" onClick={onClickDelete} visible={false} />
            </Column>

            <Column caption="Código" dataField="CodigoListaPrecios" width="80" alignment="Right" dataType="number" />
            <Column caption="Razón Social" dataField="ABM_EEX_Proveedores_RazonSocial" width="200" alignment="Left" dataType="string" />
            <Column caption="F.Comienzo" dataField="FechaComienzo" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
            <Column caption="F.Fin" dataField="FechaFin" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
            <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth={100} alignment="Left" dataType="string" />

            <MasterDetail
              enabled={true}
              component={COM_ListasPrecios_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
